<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Statutory
            <div class="settings-header__btn">
              <el-button type="success" size="mini" @click="routerLink('settings-dashboard')">Settings Dashboard</el-button>
            </div>
          </div>

          <el-form :model="form" label-position="top" size="mini" status-icon ref="form">

            <el-row :gutter="20">
              <el-col :span="8" :offset="0">

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Registration Body" prop="registrationBody">

                      <el-select v-model="form.registrationBody" placeholder="Registration Body" clearable filterable @change="changeRegistrationBody" style="width: 100%;">
                        <el-option v-for="item in registrationBodyList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>

                    </el-form-item>
                  </el-col>
                </el-row>

                <template v-if="form.registrationBody">

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Registration Date" prop="registrationDate">
                        <el-date-picker
                          style="width: 100%;"
                          v-model="form.registrationDate"
                          :clearable='true'
                          format="d MMM yy"
                          value-format="MM-dd-yyyy"
                          type="date"
                          placeholder="Registration Date">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" v-if="form.registrationBody == 1">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="DTI No." prop="dtiNo">
                        <el-input placeholder="DTI No." v-model="form.dtiNo"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" v-if="form.registrationBody == 2">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="SEC No." prop="secNo">
                        <el-input placeholder="SEC No." v-model="form.secNo"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20" v-if="form.registrationBody == 3">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="CDA No." prop="cdaNo">
                        <el-input placeholder="CDA No." v-model="form.cdaNo"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="24" :offset="0">
                      <el-form-item label="Line of Business" prop="lineOfBusiness">
                        <el-input placeholder="Line of Business" v-model="form.lineOfBusiness"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="12" :offset="0">
                      <div v-if="files.phic">
                        <div class="file-row">
                          <span @click="viewFile(files.phic.url, files.phic, -1, false)" class="file-row__file-name">{{ files.phic.name }}</span>
                          <el-button
                              size="mini"
                              type="danger"
                              plain
                              icon="el-icon-delete"
                              @click="removeFile(files.phic, 58, 'phic')"></el-button>
                        </div>
                      </div>
                      <el-button v-else style="width:100%" @click="() => $refs.phic.click()">
                        Upload File
                      </el-button>
                      <input ref='phic' v-show="false" @change="handlePhicFile" type="file">
                    </el-col>
                  </el-row>

                </template>

              </el-col>
              <el-col :span="8" :offset="0">

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Barangay" prop="barangay">
                      <el-input :placeholder="$t('settings_statutoryInformation_barangay')" v-model="form.barangay"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <h5>PHIC</h5> -->

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Philippine Health Insurance Corporation (PHIC)#" prop="phicN">
                      <el-input placeholder="Philippine Health Insurance Corporation (PHIC)#" v-mask="'##-#########-#'" v-model="form.phicN"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Name (Person Responsible for filing)" prop="phicName">
                      <el-input placeholder="Name (Person Responsible for filing)" v-model="form.phicName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Title/Position of Signatory" prop="phicTitle">
                      <el-input placeholder="Title/Position of Signatory" v-model="form.phicTitle"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="TIN of Signatory" prop="phicTIN">
                      <el-input placeholder="TIN of Signatory" v-mask="'###-###-###'" v-model="form.phicTIN"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <el-row :gutter="20">
                  <el-col :span="12" :offset="0">
                    <div v-if="files.phic">
                      <div class="file-row">
                        <span @click="viewFile(files.phic.url, files.phic, 58, false)" class="file-row__file-name">{{ files.phic.name }}</span>
                        <el-button
                            size="mini"
                            type="danger"
                            plain
                            icon="el-icon-delete"
                            @click="removeFile(files.phic, 58, 'phic')"></el-button>
                      </div>
                    </div>
                    <el-button v-else style="width:100%" @click="() => $refs.phic.click()">
                      Upload File
                    </el-button>
                    <input ref='phic' v-show="false" @change="handlePhicFile" type="file">
                  </el-col>
                </el-row> -->

                <!-- <h5>SSS</h5> -->

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Social Security System (SSS) #" prop="sssN">
                      <el-input placeholder="Social Security System (SSS) #" v-mask="'##-#######-#'" v-model="form.sssN"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Name (Person Responsible for filing)" prop="phicName">
                      <el-input placeholder="Name (Person Responsible for filing)" v-model="form.sssName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Title/Position of Signatory" prop="phicTitle">
                      <el-input placeholder="Title/Position of Signatory" v-model="form.sssTitle"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="TIN of Signatory" prop="phicTIN">
                      <el-input placeholder="TIN of Signatory" v-mask="'###-###-###'" v-model="form.sssTIN"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <el-row :gutter="20">
                  <el-col :span="12" :offset="0">
                    <div v-if="files.sss">
                      <div class="file-row">
                        <span @click="viewFile(files.sss.url, files.sss, 59, false)" class="file-row__file-name">{{ files.sss.name }}</span>
                        <el-button
                            size="mini"
                            type="danger"
                            plain
                            icon="el-icon-delete"
                            @click="removeFile(files.sss, 59, 'sss')"></el-button>
                      </div>
                    </div>
                    <el-button v-else style="width:100%" @click="() => $refs.sss.click()">
                      Upload File
                    </el-button>
                    <input ref='sss' v-show="false" @change="handleSssFile" type="file">
                  </el-col>
                </el-row> -->

                <!-- <h5>HDMF</h5> -->

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Home Development Mutual Fund (HDMF) #" prop="hdmfN">
                      <el-input placeholder="Home Development Mutual Fund (HDMF) #" v-mask="'############'" v-model="form.hdmfN"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Name (Person Responsible for filing)" prop="phicName">
                      <el-input placeholder="Name (Person Responsible for filing)" v-model="form.hdmfName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="Title/Position of Signatory" prop="phicTitle">
                      <el-input placeholder="Title/Position of Signatory" v-model="form.hdmfTitle"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="20">
                  <el-col :span="24" :offset="0">
                    <el-form-item label="TIN of Signatory" prop="phicTIN">
                      <el-input placeholder="TIN of Signatory" v-mask="'###-###-###'" v-model="form.hdmfTIN"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <!-- <el-row :gutter="20">
                  <el-col :span="12" :offset="0">
                    <div v-if="files.hdmf">
                      <div class="file-row">
                        <span @click="viewFile(files.hdmf.url, files.hdmf, 60, false)" class="file-row__file-name">{{ files.hdmf.name }}</span>
                        <el-button
                            size="mini"
                            type="danger"
                            plain
                            icon="el-icon-delete"
                            @click="removeFile(files.hdmf, 60, 'hdmf')"></el-button>
                      </div>
                    </div>
                    <el-button v-else style="width:100%" @click="() => $refs.hdmf.click()">
                      Upload File
                    </el-button>
                    <input ref='hdmf' v-show="false" @change="handleHdmfFile" type="file">
                  </el-col>
                </el-row> -->

              </el-col>
            </el-row>

            <el-form-item style="margin-top: 20px;">
              <el-button @click="save('form')" class="modal__btn" type="primary" plain size="small">{{$t('settings_companyAdditionalInfo_save')}}</el-button>
            </el-form-item>
          </el-form>

          <div v-if="viewerType == 1">
            <sweet-modal v-if="viewerType == 1" ref="nestedChild">
              <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
          </div>
          <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="getViewerSettings">
              <img :src="fileUrl" :key="fileUrl" />
            </div>
          </div>
          <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
              <span>x</span>
            </div>
            <Media
              :kind="'video'"
              :controls="true"
              :src="fileUrl"
            >
            </Media>
          </div>
          <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
              <span>x</span>
            </div>
            <Media
              :kind="'audio'"
              :controls="true"
              :src="fileUrl"
            >
            </Media>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { viewEditFileMixin } from '../../../mixins/viewEditFileMixin'
import Media from '@dongido/vue-viaudio'
export default {
  name: 'settingStatutory',
  comments: {
    Media
  },
  mixins: [viewEditFileMixin],
  computed: {
    ...mapGetters([
      'getViewerSettings'
    ]),
  },
  created() {
    this.getStatutory()
    this.getFiles()
  },
  data() {
    return {
      registrationBodyList: [
        {id: 1, name: 'Department of Trade & Industry (DTI)'},
        {id: 2, name: 'Securities and Exchange Commission (SEC)'},
        {id: 3, name: 'Cooperative Development Authority (CDA)'},
      ],

      form: {
        registrationBody: null,
        registrationDate: null,
        dtiNo: null,
        secNo: null,
        cdaNo: null,
        lineOfBusiness: null,

        barangay: null,

        // PHIC
        phicN: null,
        phicName: null,
        phicTitle: null,
        phicTIN: null,

        // SSS
        sssN: null,
        sssName: null,
        sssTitle: null,
        sssTIN: null,

        //HDMF
        hdmfN: null,
        hdmfName: null,
        hdmfTitle: null,
        hdmfTIN: null,
      },
      files: {
        phic: null,
        sss: null,
        hdmf: null
      }
    }
  },
  methods:{
    routerLink(page) {
      this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
    },
    changeRegistrationBody() {
      this.form.registrationDate = null
      this.form.dtiNo = null
      this.form.secNo = null
      this.form.cdaNo = null
      this.form.lineOfBusiness = null
    },
    getStatutory(){
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
        .get(`/api/v1/companies/itemCompanyStaturyInfo?companyId=${this.$route.query.companyId}`)
        .then(response => {
          this.form.registrationBody = response.data.item.registrationBody
          this.form.registrationDate = response.data.item.registrationDate
          this.form.dtiNo = response.data.item.dtiNo
          this.form.secNo = response.data.item.secNo
          this.form.cdaNo = response.data.item.cdaNo
          this.form.lineOfBusiness = response.data.item.lineOfBusiness

          this.form.barangay = response.data.item.barangay
          // PHIC
          this.form.phicN = response.data.item.phicN
          this.form.phicName = response.data.item.phicName
          this.form.phicTitle = response.data.item.phicTitle
          this.form.phicTIN = response.data.item.phicTIN
          // SSS
          this.form.sssN = response.data.item.sssN
          this.form.sssName = response.data.item.sssName
          this.form.sssTitle = response.data.item.sssTitle
          this.form.sssTIN = response.data.item.sssTIN
          //HDMF
          this.form.hdmfN = response.data.item.hdmfN
          this.form.hdmfName = response.data.item.hdmfName
          this.form.hdmfTitle = response.data.item.hdmfTitle
          this.form.hdmfTIN = response.data.item.hdmfTIN
          loader.hide()
        })
        .catch(error => {
          console.log('An error occurred:', error);
          loader.hide()
        });
    },
    save(form){
      this.$refs[form].validate((valid) => {
        if (valid) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/companies/saveStaturyInfo?companyId=${this.$route.query.companyId}`, this.form)
            .then(response => {
              this.$message({
                type: 'success',
                message: this.$t('settings_statutoryInformation_companyStatutoryInfoSaved')
              });
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }
      });
    },
    async getFiles() {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      try {
        const { data } = await axios.post(`/api/v1/entityFiles/listOfArrTypeId?entityId=${this.$route.query.companyId}`, { entityTypeIdArr: [58, 59, 60] })

        data.list.forEach(val => {
          if (val.entityTypeId === 58) {
            this.files.phic = val
          }
          if (val.entityTypeId === 59) {
            this.files.sss = val
          }
          if (val.entityTypeId === 60) {
            this.files.hdmf = val
          }
        })
        console.log('list', data)
      } catch (err) {
        console.log(err)
      }
    },
    async handlePhicFile(e) {
      // this.files.phic = e.target.files[0]
      await this.uploadFile(e.target.files[0], 58)
      this.$refs.phic.value = null
      await this.getFiles()
    },
    async handleSssFile(e) {
      // this.files.sss = e.target.files[0]
      await this.uploadFile(e.target.files[0], 59)
      this.$refs.sss.value = null
      await this.getFiles()
    },
    async handleHdmfFile(e) {
      // this.files.hdmf = e.target.files[0]
      await this.uploadFile(e.target.files[0], 60)
      this.$refs.hdmf.value = null
      await this.getFiles()
    },
    async uploadFile(file, entityTypeId) {
      const loader = this.$loading.show()
      try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('convert', 'false')
        formData.append('entityId', this.$route.query.companyId)
        formData.append('historyEntityId', '0')
        formData.append('taskId', 'null')
        formData.append('entityTypeId', entityTypeId)
        formData.append('oldParentId', null)
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.post(`/api/v1/entityFiles/create?companyId=${this.$route.query.companyId}`, formData)
        loader.hide()
        await this.getFiles()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    },
    async removeFile(file, entityTypeId, type) {
      const loader = this.$loading.show()
      try {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        await axios.get(`/api/v1/entityFiles/delete?companyId=${this.$route.query.companyId}&fileId=${file.id}&entityId=${this.$route.query.companyId}&historyEntityId=0&taskId=null&entityTypeId=${entityTypeId}&deleteChild=false`)
        this.files[type] = null
        await this.getFiles()
        loader.hide()
      } catch (err) {
        loader.hide()
        console.log(err)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper {
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

.file-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &__file-name {
    max-width: 220px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }
}

/deep/.el-form-item__label {
  color: #000;
  font-weight: bold;
  padding: 0;
}
</style>
